import "stylesheets/gulped-embed.scss";

// Must Have
import 'jquery';
import Rails from 'rails-ujs';
Rails.start();

// Gulp/assets
import 'javascripts/global';
import 'javascripts/gulped/embed/base';
